export default __webpack_public_path__ + "locales/sl/EmptyView.json?hash=6e25e007b3a867837138aaba37848fc9";